export enum HittersRoutes {
  CreateHitter = 'create-hitter',
  DeleteHitters = 'delete-hitters',
  DeleteSessions = 'delete-sessions',
  GetHit = 'get-hit',
  GetHitByFire = 'get-hit-by-fire',
  GetHitter = 'get-hitter',
  GetHitters = 'get-hitters',
  GetProfileHits = 'get-profile-hits', // i.e. which hits are relevant for the selected period (for summary tab)
  GetSessionHits = 'get-session-hits',
  GetSessionSummaries = 'get-session-summaries',
  UpdateHit = 'update-hit',
  UpdateHits = 'update-hits',
  UpdateHitter = 'update-hitter',
  UploadCsv = 'upload-csv',
  UploadHitterAvatar = 'upload-hitter-avatar',
  UpsertDetectionIssue = 'upsert-detection-issue',
  UpsertMetadata = 'upsert-metadata',
}
